module.exports = __webpack_public_path__ + "img/off_lavadora_cajas.b625c0ea.png";